import React, { createContext, useState, useContext, useEffect } from "react";
import { useAuth } from "./AuthContext";
import { apiRequest } from "../utils/api";

export const EmpresaContext = createContext();

export function EmpresaProvider({ children }) {
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(false);
  const { isAdmin, usuario, loading: authLoading } = useAuth();

  const getEmpresaActual = () => {
    if (isAdmin()) {
      return empresaSeleccionada;
    }
    return usuario?.empresa;
  };

  const seleccionarEmpresa = (empresa) => {
    if (isAdmin()) {
      setEmpresaSeleccionada(empresa);
      if (empresa) {
        localStorage.setItem('empresaSeleccionada', JSON.stringify(empresa));
      } else {
        localStorage.removeItem('empresaSeleccionada');
      }
    }
  };

  const limpiarEmpresaSeleccionada = () => {
    setEmpresaSeleccionada(null);
    localStorage.removeItem('empresaSeleccionada');
  };

  const cargarEmpresas = async () => {
    if (isAdmin()) {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        
        if (!token) {
          return;
        }
        const response = await apiRequest('/empresas');
        if (response.ok) {
          const data = await response.json();
          setEmpresas(data);
        } else {
          const errorData = await response.json().catch(() => ({}));
          console.error('❌ Error al cargar empresas:', response.status, errorData);
        }
      } catch (error) {
        console.error('❌ Error de red al cargar empresas:', error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (authLoading) {
      return;
    }
    
    if (isAdmin() && empresas.length === 0) {
      const stored = localStorage.getItem('empresaSeleccionada');
      if (stored) {
        try {
          setEmpresaSeleccionada(JSON.parse(stored));
        } catch (e) {
          console.error('❌ Error al parsear empresa seleccionada:', e);
          localStorage.removeItem('empresaSeleccionada');
        }
      }
      cargarEmpresas();
    }
  }, [authLoading, usuario?.rol]); 

  return (
    <EmpresaContext.Provider value={{
      empresaSeleccionada,
      empresaActual: getEmpresaActual(),
      empresas,
      loading: loading || authLoading,
      seleccionarEmpresa,
      limpiarEmpresaSeleccionada,
      cargarEmpresas,
      isAdmin
    }}>
      {children}
    </EmpresaContext.Provider>
  );
}

export const useEmpresa = () => {
  const context = useContext(EmpresaContext);
  if (!context) {
    throw new Error("useEmpresa debe usarse dentro de un EmpresaProvider");
  }
  return context;
}; 
